import type { TextSizingConfigs } from './utils';
import { devices } from '../common/devices';
import { colors, darkThemeSelector, styled } from '../stitches.config';
import { Text } from './Text';

const bodyVars = {
  touch: {
    size: 15,
    lineHeight: 24,
  },
  mouse: {
    size: 13,
    lineHeight: 20,
  },
} as const satisfies TextSizingConfigs;

const BodyBase = {
  color: colors.bodyNeutralLight,
  [darkThemeSelector]: {
    color: colors.bodyNeutralDark,
  },
  variants: {
    internal: {
      true: {
        color: colors.internalBodyLight,
        [darkThemeSelector]: {
          color: colors.internalBodyDark,
        },
      },
      false: {},
    },
  },
};

export const BodySansSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${bodyVars.touch.size}`,
      lineHeight: `$${bodyVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${bodyVars.mouse.size}`,
      lineHeight: `$${bodyVars.mouse.lineHeight}`,
    },
  },
};

export const BodyMonoSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${bodyVars.touch.size - 1}`,
      lineHeight: `$${bodyVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${bodyVars.mouse.size - 1}`,
      lineHeight: `$${bodyVars.mouse.lineHeight}`,
    },
  },
};

export const Body = styled(Text, BodyBase, {
  variants: {
    family: {
      regular: BodySansSizes,
      monospace: BodyMonoSizes,
    },
  },
  defaultVariants: {
    family: 'regular',
  },
});
Body.displayName = 'Body';
